module.exports = __webpack_public_path__ + "img/about-tile-one.4a8a65fd.png";